var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticStyle:{"margin-bottom":"10px"},attrs:{"type":"primary","disabled":!!_vm.$attrs.disabled},on:{"click":_vm.FBADownExcl}},[_vm._v("下载EXCEL")])
}
var staticRenderFns = []

export { render, staticRenderFns }